/* eslint-disable func-names */
/* eslint-disable no-multi-assign */
/* eslint-disable no-unused-vars */
/* eslint-disable spaced-comment */
/* eslint-disable no-param-reassign */
import { RequestHelp_Banner } from './RequestHelp_Banner';
import { RequestHelp_Util } from './RequestHelp_Util';
import { RequestHelp_Tutorial } from './RequestHelp_Tutorial';
import OMT_UI_RequestHelpScroll from '../../../OMT_UI/Scroll/OMT_UI_RequestHelpScroll';
import { OMT_UI_InviteMoreFriendsButton } from '../../../OMT_UI/Buttons/OMT_UI_InviteMoreFriendsButton';
import { Window } from '../../../00_IMMEDIATE/Window';
import OMT_UI_SquareButton, { BUTTONCOLOURS } from '../../../OMT_UI/OMT_UI_SquareButton';
import RequestHelp_Wheel from './RequestHelp_Wheel';
import { GiftGraphic } from '../GiftUI/GiftGraphic';
import OMT_UI_DrawUtil from '../../../OMT_UI/Drawing/OMT_UI_DrawUtil';

/**
 * The big file that is requestHelp!
 *
 * G.OMTsettings.requestHelp.positionals = {
    useTwoPiecePopup: boolean,      //default false
    threePieceOffsetMid: number,    //default -1
    maskRadius: number,             //default 25
    listOffsetX: number,            //default 0
    scrollbarOffsetHeight: number,  //default 0
    friendBg1Color: number,         //default the color of Fish story's
    friendBg1Color: number,         //default the color of Fish story's
    friendBg3Color: number,         //default the color of Fish story's
    titleText: string,              //The font style for the title text
 * }
 * @author Sandra Koo
 */

// Text styles
const blueText = {
  style: 'font-purple',
  fontSize: 30,
  align: 'left',
  lineSpacing: -10,
};

const friendRequestText = {
  style: 'font-white',
  fontSize: 36,
  align: 'center',
  lineSpacing: -10,
};

const friendRequestTimerText = {
  style: 'font-white',
  fontSize: 14,
  align: 'center',
  lineSpacing: -10,
};

const prizeText = {
  style: 'font-num-blue',
  fontSize: 60,
  scaleStroke: true,
  align: 'center',
  lineSpacing: -10,
};

const helpReceivedText = {
  style: 'font-white',
  fontSize: 48,
  align: 'center',
  lineSpacing: -10,
};

// Const IDs for special things but still accessed globally in here at least
const COOLDOWNKEY = 'requestHelpData';
const GINGYID = 'SG_bot'; // For Gingy
const FRIENDREQSENT = 'Friend request was sent!'; // For if a request was sent
const FRIENDLESS = 'Your friends will be listed here.'; // For if you have no friends

const WindowStates = { // State machines!!
  Friend: 0,
  Wheel: 1,
  Prize: 2,
};

export class requestHelp extends Window {
  /**
   * constructor
   * @param {Object} parent
   * @param {Object} levelData
   */
  constructor(parent, levelData) {
    super(parent);

    this.currentState = undefined;
    this.windowStateFuncs = null;

    this.prizeList = {}; // Object prizes

    this.friendEntryDimensions = {}; // Phaser.Rectangle assigned soon after I figure out how big the bg is
    this.friendWindowDimension = null; // Phaser.Rectangle assigned soon after I figure out how big the bg is again
    this.availableListPosition = 0; // Y position that is after the subtext
    this.numOfVisibleEntries = 4; // Number of visible entries when loaded. Strangely determines size of box and visible area
    this.friendContainerOffsetX = G.OMTsettings.requestHelp.positionals.listOffsetX || 0; // Offset the friend container by x in the G.OMTsettings

    this.saveStateMgr = G.saveState;
    this.isFirstTimeSpinning = this.saveStateMgr.requestHelp_getNumOfSpins() === 0;

    this.parentLevelName = levelData.parentName;
    this.currentLevelData = levelData.currentLevelData; // Current level, given by Window_Level
    this.friendRequestIsSent = false; // Is that sent?
    this.isFriendless = false; // Playing with no friends?
    this.snapToFriendTarget = null;

    this.wideScreenLayout = game.width / game.height > 3 / 4;
    this.isTutorialLayout = this.saveStateMgr.requestHelp_shouldTutorialShow();
    this.rh_gingyTutorial = null; // Used to see if tutorial is there or not, also the tutorial character
    this.rh_tutorialHandTarget = null; // {friendDisplay: displayObject, friendButton: displayObject}. Used to find the target of what to point
    if (this.isTutorialLayout) {
      this.rh_gingyTutorial = new RequestHelp_Tutorial({ game: G.Game, tutorialBar: true });
    }

    this.rh_inventory = levelData.inventory;
    this.saveStateMgr.requestHelp_increaseOpened(false); // Should only be called once
    this.startReqHelp();
  }

  /**
  * start req help flow
  */
  async startReqHelp() {
    // can this be deleted ??
    // set inventory reference and toggle
    /*
    if (this.wideScreenLayout) {
      this.rh_inventory.adjustSize(0.9);
    }
    else {
      this.rh_inventory.adjustSize(1);
    }

    this.rh_inventory.toggleInventory(this.rh_inventory.items.length > 0);
    */

    this.inviteFriendButton = null; // initialize. Will use this later
    this.rh_friendWindow = this.friendWindowInit(); // Make the friend window
    this.onRequestHelpResize(); // positioning
    this.gingyPresent = G.makeImage(0, 0, 'MysteryGift_Cookie_boosts', 0.5, null); // Image of gingy above/below
    this.initPrizeList(this.rh_inventory); // init inventory

    this.rh_wheel = new RequestHelp_Wheel({ // Wheel
      prizeList: this.prizeList,
      isFirstTimeSpinning: this.isFirstTimeSpinning,
      autoStart: true,
    });
    this.addChild(this.rh_wheel.wheelDisplay); // Add it in
    const bannerText = (typeof this.currentLevelData === 'number') ? `${OMT.language.getText('Level')} ${this.currentLevelData + 1}` : OMT.language.getText('Daily Challenge');
    this.rh_banner = new RequestHelp_Banner({ // Banner
      text: bannerText,
      bannerImg: 'gold_wheel_ribbon',
    });
    this.rh_banner.y = -275;
    this.addChild(this.rh_banner);
    this.rh_prizePack = await this.prizeScreenInit(); // Make the prize screen


    this.windowStateFuncs = []; // Filling in the states
    this.windowStateFuncs[WindowStates.Friend] = {
      onEnter: async (snapToEnd) => { // Friend window enter
        this.rh_banner.visible = false; // Hide banner
        let rh_friendData;
        try {
          rh_friendData = await this.assembleFriendData(); // Get friend data
        } catch (err) {
          rh_friendData = [this.createBotData()]; // Or just bot data
        }
        this.rh_friendContainer = await this.displayFriendData(rh_friendData); // Object, Make graphics
        this.rh_friendContainer.display.x = this.rh_friendContainer.display.width / 2;
        this.omtScrollBar = new OMT_UI_RequestHelpScroll({
          scrollRect: new Phaser.Rectangle(
            -this.friendEntryDimensions.width * 0.485,
            this.availableListPosition,
            this.friendEntryDimensions.width * 0.98,
            this.friendEntryDimensions.height * (this.numOfVisibleEntries - 0.02), // Make it slightly smaller so that isWithinVisibleMask will not detect the edge
          ),
          scrollBarWidth: 12,
          scrollBarMiddleWidth: 80,
          mask: {
            mask: this.makeMaskGraphic(new Phaser.Rectangle(0, 0, this.friendEntryDimensions.width * 0.98, this.friendEntryDimensions.height * (this.numOfVisibleEntries - 0.02))),
            proxy: this.makeMaskGraphic(new Phaser.Rectangle(0, 0, this.friendEntryDimensions.width * 0.98, this.friendEntryDimensions.height * (this.numOfVisibleEntries - 0.02))),
          },
        });
        this.omtScrollBar.content.addChild(this.rh_friendContainer.display);
        this.rh_friendWindow.addChild(this.omtScrollBar);
        this.rh_friendWindow.update = () => {
          this.manualFriendWindowUpdate();
        };
        this.rh_friendWindow.visible = true;
        // Is scrolling and snapping to the end and not friendless. Usually for the invite message feedback
        if (snapToEnd && this.snapToFriendTarget) {
          this.snapToEntry(this.snapToFriendTarget);
          this.snapToFriendTarget = null;
        }

        if (this.isTutorialLayout && this.rh_tutorialHandTarget) { // Tutorial!?
          this.rh_gingyTutorial.toggleVisibility(true);
          this.tutorialStep(this.saveStateMgr.requestHelp_getTutorialStep());
        }
      },
      onExit: () => { // Friend window exit
        this.rh_friendWindow.visible = false;
        this.rh_friendWindow.update = () => {};
        if (this.gingyPresent && this.gingyPresent.parent) {
          this.gingyPresent.parent.removeChild(this.gingyPresent);
        }
        if (this.rh_friendContainer) {
          this.destroyOldFriendData(this.rh_friendContainer); // Destroys graphics
          this.rh_friendContainer.display.destroy();
          this.rh_friendWindow.removeChild(this.rh_friendContainer.display);
        }
        if (this.rh_friendDisplayScrollInput) {
          this.removeScrollableInput(this.rh_friendDisplayScrollInput); // removes listeners
          this.rh_friendDisplayScrollInput = null;
        }
        if (this.omtScrollBar) {
          this.omtScrollBar.destroy();
        }
        if (this.rh_gingyTutorial) {
          this.rh_gingyTutorial.toggleVisibility(false);
        }
      },
    };
    this.windowStateFuncs[WindowStates.Wheel] = {
      onEnter: () => { // Wheel enter
        this.rh_wheel.signals.changeState.addOnce((wheelVis) => {
          this.changeState(WindowStates.Prize, wheelVis);
        });
        this.rh_wheel.signals.collectWheelPrizeInternally.addOnce((prizeList) => {
          this.collectWheelPrizeInternally(prizeList);
        });
        this.rh_wheel.signals.collectWheelPrizeVisually.addOnce((prizeSnapshot) => {
          this.collectWheelPrizeVisually(prizeSnapshot);
        });
        this.rh_wheel.fillWheel();
        this.rh_wheel.enterTheWheel(); // Wheel entrance
        RequestHelp_Util.enterTheBanner(this.rh_banner); // Banner entrance
      },
      onExit: (wheelVisibility) => { // Wheel exit
        if (wheelVisibility === undefined) { wheelVisibility = false; } // If nothing was given, false
        this.rh_wheel.container.visible = wheelVisibility;
        if (!wheelVisibility) { // Remove listeners if needed
          this.rh_wheel.signals.changeState.removeAll();
          this.rh_wheel.signals.collectWheelPrizeInternally.removeAll();
          this.rh_wheel.signals.collectWheelPrizeVisually.removeAll();
          this.rh_wheel.signals.wheelFinished.removeAll();
        }
        // CollectWheelPrizeVisually will hide the wheel if otherwise
      },
    };
    this.windowStateFuncs[WindowStates.Prize] = {
      onEnter: () => { // Prize screen enter
        this.rh_prizePack.display.visible = true;
      },
      onExit: () => { // Prize Screen exit. Removes wheel things
        this.rh_prizePack.display.visible = false;
        this.rh_wheel.container.visible = false;
        this.rh_wheel.signals.changeState.removeAll();
        this.rh_wheel.signals.collectWheelPrizeInternally.removeAll();
        this.rh_wheel.signals.collectWheelPrizeVisually.removeAll();
        this.rh_wheel.signals.wheelFinished.removeAll();
      },
    };

    this.windowStateFuncs[WindowStates.Friend].onExit(); // Making sure the screen is clear
    this.windowStateFuncs[WindowStates.Wheel].onExit();
    this.windowStateFuncs[WindowStates.Prize].onExit();

    this.changeState(WindowStates.Friend); // Starting with friends
  }

  /**
   * Changes to a new Window State. Calls onExit(booleanArg) then onEnter(booleanArg)
   * @param {this.WheelStates} newState
   * @param {boolean} booleenArg
   */
  changeState(newState, booleenArg) {
    if (this.currentState !== undefined) {
      this.windowStateFuncs[this.currentState].onExit(booleenArg); // Not all onExit/Enter uses the boolean args, but if they do then...
    }
    this.currentState = newState;
    this.windowStateFuncs[this.currentState].onEnter(booleenArg); // Something will have to be done :>
  }

  /**
   * Hides tutorial, brings back to prelevel, and close
   */
  closeWindow() {
    if (this.rh_gingyTutorial) {
      this.rh_gingyTutorial.close();
    }
    super.closeWindow(this.rh_destroy, this);
    G.sb('pushWindow').dispatch(
      [this.parentLevelName, this.currentLevelData, { inventory: this.rh_inventory }],
      false, this.parent.layerName,
    );
  }

  /**
   * Called from onDestroy call. Will do more clean
   */
  destroy() {
    if (this.rh_banner) {
      this.rh_banner.destroy();
    }
    if (this.rh_wheel) {
      this.rh_wheel.cleanUp();
    }

    if (this.rh_gingyTutorial) {
      this.rh_gingyTutorial.destroy();
    }

    if (this.rh_tutorialHand) {
      this.rh_tutorialHand.destroy();
    }

    if (this.rh_friendContainer) {
      this.destroyOldFriendData(this.rh_friendContainer); // Destroys graphics
      this.rh_friendContainer.display.visible = false;
      this.rh_friendContainer.display.destroy();
      this.rh_friendWindow.removeChild(this.rh_friendContainer.display);
    }

    if (this.rh_friendWindow) {
      this.rh_friendWindow.destroy();
    }

    if (this.omtScrollBar) {
      this.omtScrollBar.destroy();
    }

    super.destroy();
  }

  /**
   * Grab prize list and format it. Also merges already claimed prizes and switches them to the off version
   */
  initPrizeList(inventory) {
    const theList = G.gift.getRequestHelpSenderGifts();
    this.prizeList = {
      off: RequestHelp_Util.copyPrizeData(theList.off),
      current: RequestHelp_Util.copyPrizeData(theList.on),
      predeterminedPrize: -1,
    };

    for (let i = 0; i < inventory.items.length; i++) {
      const inventoryItem = inventory.items[i];
      for (let j = 0; j < this.prizeList.current.length; j++) {
        if (this.prizeList.current[j].prize === inventoryItem.prize) {
          this.prizeList.current[j] = this.prizeList.off[j]; // Switch to the off version
          break;
        }
      }
    }
  }

  /**************************************************
   *
    ______ _____  _____ ______ _   _ _____
  |  ____|  __ \|_   _|  ____| \ | |  __ \
  | |__  | |__) | | | | |__  |  \| | |  | |
  |  __| |  _  /  | | |  __| | . ` | |  | |
  | |    | | \ \ _| |_| |____| |\  | |__| |
  |_|    |_|  \_\_____|______|_| \_|_____/
  ************************************************ */
  friendWindowInit() {
    const layoutPositions = this.getLayoutPosition();

    const friendWindow = new Phaser.Group(G.Game, this);
    friendWindow.scale.set(layoutPositions.friendWindowScale, layoutPositions.friendWindowScale);
    friendWindow.y = layoutPositions.friendWindowY;

    const bg = new Phaser.Group(G.Game, null);
    if (!G.OMTsettings.requestHelp.positionals.useTwoPiecePopup) { // Normal pop up uses 3 pieces..
      const midOffsetX = G.OMTsettings.requestHelp.positionals.threePieceOffsetMid || -1;
      const top = G.makeImage(0, 0, 'popup_top', [0.5, 0], bg);
      const mid = G.makeImage(midOffsetX, top.height - 2, 'popup_center', [0.5, 0], bg);
      mid.height = (100 * (this.numOfVisibleEntries - 1)) + 82;
      const bot = G.makeImage(0, mid.y + mid.height - 2, 'popup_bottom', [0.5, 0], bg);
    } else { // But if you want 2 pieces then it'll have to be like this!
      const bot = G.makeImage(0, 0, 'popup_bg_bottom', [0.5, 0], bg);
      const top = G.makeImage(0, 0, 'popup_bg_top', [0.5, 0], bg);
      bot.y = top.y + top.height * 0.45;
    }

    this.friendWindowDimension = bg.getBounds();
    this.friendEntryDimensions = new Phaser.Rectangle(0, 0, bg.width * 0.88, 100);

    const titleTxt = new G.Text(0, layoutPositions.titleY, OMT.language.getText('Request Help'), 'window-requestHelp', 0.5, 370);
    if (!G.OMTsettings.requestHelp.positionals.titleText) {
      titleTxt.setShadow(2, 4, 'rgba(0,0,0,0.5)', 5);
    }
    bg.addChild(titleTxt);

    const subtitle = new G.Text(0, layoutPositions.subY, OMT.language.getText('Ask a friend for a Free Booster!'), 'window-blue', 0.5, 460, 96, true, 'center');
    this.availableListPosition = bg.y + subtitle.y + subtitle.height - 35; // Safe Y position for things
    bg.addChild(subtitle);

    const closeButton = new G.Button(0, 0, 'btn_x', () => { this.closeWindow(); });
    closeButton.x = (bg.width - closeButton.width) / 2;
    closeButton.y = bg.y + closeButton.height / 2;
    this.buttonsList.push(closeButton);
    bg.addChild(closeButton);

    friendWindow.addChild(bg);
    this.inviteFriendButton = new OMT_UI_InviteMoreFriendsButton(() => { this.inviteFriends(); });
    G.Utils.cleanUpOnDestroy(this.inviteFriendButton, G.sb('onScreenResize').add(() => { this.onRequestHelpResize(); }));
    friendWindow.addChild(this.inviteFriendButton);

    // If we're doing this tutorial, the hand isn't set yet, and its step 1
    if (this.rh_gingyTutorial && !this.rh_tutorialHandTarget && this.saveStateMgr.requestHelp_getTutorialStep() === 1) {
      this.rh_tutorialHandTarget = {
        display: friendWindow,
        target: this.inviteFriendButton,
        offset: { x: this.inviteFriendButton.width * 0.35, y: 0 },
      };
      this.rh_gingyTutorial.setTarget(this.rh_tutorialHandTarget);
    }

    return friendWindow;
  }

  /**
   * Assembles an array of things that should be seen on the window.
   * Order is
   * Humans (off cooldown)
   * bot (off cooldown)
   * Humans (on cooldown)
   * bot (on cooldown)
   * special messages
   */
  async assembleFriendData() {
    const friendData = await RequestHelp_Util.retrieveFriends(); // {off:[], on:[]};//

    const friendAmount = friendData.off.length + friendData.on.length; // friend count
    this.isFriendless = friendAmount === 0; // No real friends :'(

    if (this.isFriendless) {
      const tempKittyData = this.createBotData(); // blank bot data

      switch (checkedFriend.data.name) { // Assign bot portraits here... It doesn't have to but just in case?
        case (OMT.language.getText('Gingy')):
          checkedFriend.data.image = 'gingerbread_man_large';
          break;
      }

      const cooldownTime = this.saveStateMgr.getUserCooldownRemaining(COOLDOWNKEY, GINGYID);
      if (cooldownTime === 0) {
        friendData.off.push(tempKittyData);
      }
      else {
        friendData.on.push(tempKittyData);
      }
    }

    // If there is any change in length of friend list
    const lastAmount = this.saveStateMgr.requestHelp_getFriendAmount();
    if (lastAmount !== friendAmount && lastAmount > -1) {
      this.friendRequestIsSent = this.saveStateMgr.requestHelp_shouldInvitationShow(friendAmount);
    } else {
      this.friendRequestIsSent = this.saveStateMgr.requestHelp_shouldInvitationShow();
    }

    const sortedFriends = friendData.off.concat(friendData.on); // combine the two

    // yes friend req was sent within 24h
    if (this.friendRequestIsSent) {
      sortedFriends.push({
        id: FRIENDREQSENT,
        requestHelpData: {},
      });
    } else if (this.isFriendless) { // No friends, very last
      sortedFriends.push({
        id: FRIENDLESS,
        requestHelpData: {},
      });
    }

    return sortedFriends;
  }

  /**
   * Creates bot data
   */
  createBotData() {
    return {
      id: GINGYID,
      image: 'gingerbread_man_large',
      name: OMT.language.getText('Gingy'),
      maxLevel: 999,
    };
  }

  /**
   * Draws friend data based on data given below, like this!
   *
   * friendList = [
   *  {
   *    id: string (id number) || "SG_bot" || "Friend request was sent!",
   *    image: string (url)
   *    maxLevel: int,
   *    name: string,
   *    requestHelpData: {
   *      timeStart: int (Date.now()),
   *      duration: int
   *    }
   *  }
   * ]
   *
   * @param {Array<Object>} friendList
   * @returns {display: Phaser.Group, friendDisplays:Array<Phaser.Group>, dimensions:Phaser.Rectangle}
   */
  async displayFriendData(friendList) {
    const bg1 = G.OMTsettings.requestHelp.positionals.friendBg1Color || 0xffca93;
    const bg2 = G.OMTsettings.requestHelp.positionals.friendBg2Color || 0xfee6c4;
    const alternatingBgs = [bg1, bg2]; // Background colours change
    const feedbackBg = G.OMTsettings.requestHelp.positionals.friendBg3Color || 0xffa200; // Special message background
    const friendDisplays = []; // Collection of displays
    const friendDisplayContainer = new Phaser.Group(G.Game, this.rh_friendWindow); // Something to hold them all

    friendDisplayContainer.y = 0;// this.availableListPosition;  //Safe spot
    let nextY = 0;
    // let friendDisplayDimensions = new Phaser.Rectangle(-this.friendEntryDimensions.width/2, nextY, 0, 0); //Size of the entire friend container
    const originX = -this.friendEntryDimensions.width / 2;
    for (let i = 0; i < friendList.length; i++) {
      const friend = friendList[i];
      const color = (friend.id === FRIENDREQSENT || friend.id === FRIENDLESS) ? feedbackBg : alternatingBgs[i % 2]; // Assign colour
      const friendBannerPackage = this.makeFriendBanner({ friendData: friend, color }); // Make!

      friendDisplayContainer.addChild(friendBannerPackage.friendDisplay); // Add

      friendBannerPackage.friendDisplay.x = originX; // friendDisplayDimensions.x;  //position
      friendBannerPackage.friendDisplay.y = nextY;

      nextY += this.friendEntryDimensions.height; // book keeping
      // friendDisplayDimensions.width = Math.max(friendBannerPackage.friendDisplay.width, this.friendEntryDimensions.width);
      // friendDisplayDimensions.height += this.friendEntryDimensions.height;
      friendDisplays.push(friendBannerPackage);

      // If we're doing this tutorial, (the hand isn't set yet, or its the first button), and its step 0
      if (this.rh_gingyTutorial && (!this.rh_tutorialHandTarget || i === 0) && this.saveStateMgr.requestHelp_getTutorialStep() === 0) {
        this.rh_tutorialHandTarget = {
          display: friendBannerPackage.friendDisplay,
          target: friendBannerPackage.friendButton,
          offset: { x: 0, y: -friendBannerPackage.friendButton.height / 2 },
        };
        this.rh_gingyTutorial.setTarget(this.rh_tutorialHandTarget);
      }

      if (friend.id === FRIENDREQSENT) {
        this.snapToFriendTarget = friendBannerPackage;
      }
    }

    // if (friendList.length <= 2) { //If list is short, put gingy on the bottom
    this.gingyPresent.x = 0;
    this.gingyPresent.y = nextY + this.gingyPresent.height * 0.6;

    friendDisplayContainer.addChild(this.gingyPresent);
    // }
    // else {  //Otherwise on top
    //   this.gingyPresent.x = 0;
    //   this.gingyPresent.y = -this.gingyPresent.height*1.4;
    //   this.rh_friendWindow.addChildAt(this.gingyPresent, 0);
    // }

    return {
      display: friendDisplayContainer,
      friendDisplays,
      // dimensions: friendDisplayDimensions
    };
  }

  /**
   * Cleans up friend data. Removes updates, events, signals, and destroys
   */
  destroyOldFriendData(friendContainer) {
    for (let i = 0; i < friendContainer.friendDisplays.length; i++) {
      const friendBanner = friendContainer.friendDisplays[i];
      if (friendBanner.friendButton) {
        friendBanner.friendButton.update = () => {};
        friendBanner.friendButton.onClick.forget();
        friendBanner.friendButton.onClick.removeAll();
      }
      friendBanner.friendDisplay.destroy(true);
    }
  }

  /**
   * Close :(
   */
  closeRequestHelp() {
    G.sb('pushWindow').dispatch(
      ['level', this.currentLevelData, this.rh_inventory],
      false,
      game.state.current === 'World' ? G.WindowMgr.LayerNames.AboveHighScorePanel : G.WindowMgr.LayerNames.Base,
    );
    this.closeWindow();
  }

  /**
   * Event that happens when the Invite Friends button is pressed
   */
  async inviteFriends() {
    let result = false;

    result = await OMT.social.chooseContextAndInvite(); // Waiting for status...

    if (result) {
      DDNA.tracking.socialActionEvent('INVITE', '', '', '');
      this.saveStateMgr.requestHelp_sentInvitation(false);
      const oldFriendReqIsSent = this.friendRequestIsSent;
      this.friendRequestIsSent = this.saveStateMgr.requestHelp_shouldInvitationShow(); // Checks again
      if (this.saveStateMgr.requestHelp_getTutorialStep() === 1 && this.rh_gingyTutorial) {
        this.saveStateMgr.requestHelp_setTutorialStep(2, false); // Sets to step 2 of tutorial if needed
        this.rh_tutorialHandTarget = null;
        this.rh_gingyTutorial.toggleVisibility(false);
      }
      this.saveStateMgr.save();
      this.windowStateFuncs[WindowStates.Friend].onExit(); // refresh Friend window state, grab friends again, and redraw everything...
      await this.windowStateFuncs[WindowStates.Friend].onEnter(oldFriendReqIsSent !== this.friendRequestIsSent); // Snap to the bottom?
    }
  }

  /**
   * Draws individual friend row with data, like this!
   *
   * friendInfo = {friendData: {Object}, color: string}
   * @param {Object} friendInfo
   */
  makeFriendBanner(friendInfo) {
    const friendDisplay = new Phaser.Group(G.Game, null);

    const friendBg = new Phaser.Graphics(game);
    friendBg.beginFill(friendInfo.color);
    friendBg.drawRect(0, 0, this.friendEntryDimensions.width, this.friendEntryDimensions.height);
    friendBg.endFill();

    const targetAvatarImgDimension = 54;
    let avatarImage;

    // Settling avatars
    switch (friendInfo.friendData.id) {
      case GINGYID: // Its a bot
        avatarImage = G.makeImage(0, 0, friendInfo.friendData.image, 0.5);
        avatarImage.crop(new Phaser.Rectangle( // Cuts out her face!
          G.OMTsettings.elements.gingy.mugshot.x,
          G.OMTsettings.elements.gingy.mugshot.y,
          G.OMTsettings.elements.gingy.mugshot.width,
          G.OMTsettings.elements.gingy.mugshot.height,
        ), true);
        avatarImage.width = avatarImage.height = targetAvatarImgDimension;
        break;
      case FRIENDLESS: // Tells you you need friends
        // eslint-disable-next-line no-case-declarations
        const reqText = new G.Text(
          0, 0, OMT.language.getText(friendInfo.friendData.id), friendRequestText, 0, this.friendEntryDimensions.width * 0.95,
          this.friendEntryDimensions.height, true, 'center',
        );
        reqText.x = (this.friendEntryDimensions.width - reqText.width) / 2;
        reqText.y = (this.friendEntryDimensions.height - reqText.height) / 2;
        friendDisplay.addChild(friendBg);
        friendDisplay.addChild(reqText);
        return { // Further things are not needed
          friendDisplay,
          friendButton: null,
        };
      case FRIENDREQSENT: // When a request is sent, the avatar is avatar_e
        avatarImage = G.makeImage(0, 0, 'avatar_e', 0.5);
        break;
      default: // Real people
        avatarImage = G.makeExtImage(0, 0, friendInfo.friendData.image, 'avatar_e', 0.5, friendDisplay, false, function () {
          this.width = this.height = 54;
        });
        break;
    }

    const friendImage = new Phaser.Group(G.Game, null); // Avatar container
    const avatarFrame = G.makeImage(0, 0, 'avatar_frame', 0.5);
    avatarImage.width = avatarImage.height = targetAvatarImgDimension;
    avatarFrame.width = avatarFrame.height = avatarImage.width * 1.15;
    friendImage.addChild(avatarImage);
    friendImage.addChild(avatarFrame);
    const friendExpectedWH = friendImage.width = friendImage.height = this.friendEntryDimensions.height * 0.8;
    friendImage.x = 10 + friendExpectedWH / 2; // Incase the image finishes loading and is huge
    friendImage.y = this.friendEntryDimensions.height / 2;

    const availableTextSpace = this.friendEntryDimensions.width - 35; // Available width left for text
    const preCalcFriendTextX = friendImage.x + friendExpectedWH - 25; // Calculates safe X pos

    if (friendInfo.friendData.id === FRIENDREQSENT) { // If its friend request
      const reqText = new G.Text(
        preCalcFriendTextX, 0, OMT.language.getText(friendInfo.friendData.id), friendRequestText,
        0, availableTextSpace - preCalcFriendTextX, this.friendEntryDimensions.height, true, 'center',
      );
      reqText.y = (this.friendEntryDimensions.height - reqText.height) / 2;
      friendDisplay.addChild(friendBg);
      friendDisplay.addChild(friendImage);
      friendDisplay.addChild(reqText);
      return { // Make the text and return. No button needed
        friendDisplay,
        friendButton: null,
      };
    }
    // At this point FRIENDREQSENT and FRIENDLESS is returned

    const requestHelpBtn = new G.Button(0, 0, null); // new Phaser.Group(G.Game, null);  //Make the button for bot and real people
    requestHelpBtn.input.enabled = true;
    const buttonContainer = new Phaser.Group(game, requestHelpBtn);
    const actualRequestBtn = new OMT_UI_SquareButton(0, 0, {
      button: {
        tint: BUTTONCOLOURS.gray,
        dimensions: {
          width: 188,
          height: 96,
        },
        extraDetail: false,
      },
      // options: {
      //   clickFunction: {
      //     scaleOnClick: false,
      //   },
      // },
    });
    actualRequestBtn.input.enabled = false;
    buttonContainer.addChild(actualRequestBtn);
    const actualRequestButtonWidth = 125;
    buttonContainer.height *= (50 / actualRequestBtn.height);
    buttonContainer.width *= (actualRequestButtonWidth / actualRequestBtn.width);
    const gift = new GiftGraphic(-actualRequestButtonWidth / 2, -8, { giftType: 1, useFullGift: true }, null);
    // const gift = G.makeImage(-actualRequestButtonWidth / 2, -8, 'gift', 0.5, null);
    const giftScale = 70 / 187;
    gift.height *= giftScale;
    gift.width *= giftScale;

    const requestHelpText = new G.Text(0, 0, OMT.language.getText('Request Help'), friendRequestTimerText, 0.5, 85, 85, true, 'center');
    const friendPack = {
      friendDisplay,
      friendButton: requestHelpBtn,
    };

    const onFriendReqClick = () => { // Make variable for click function
      if (requestHelpBtn.input.enabled) {
        this.onRequestFriendHelp(friendInfo.friendData);
      }
    };

    requestHelpBtn.update = () => {
      const timeLeft = this.saveStateMgr.getUserCooldownRemaining(COOLDOWNKEY, friendInfo.friendData.id);
      if (timeLeft > 0) {
        const timeString = TimeUtil.getTimeCode(timeLeft);
        if (requestHelpText.text !== timeString) {
          requestHelpText.setText(timeString);

          if (requestHelpBtn.onClick.has(onFriendReqClick, this)) {
            requestHelpBtn.onClick.remove(onFriendReqClick, this);
          }
        }
      } else { // Called once because it'll replace update at the end
        actualRequestBtn.setColour(BUTTONCOLOURS.blue);
        requestHelpText.setText(OMT.language.getText('Request Help'));
        requestHelpText.x = 5;
        requestHelpText.y = 2;

        if (!requestHelpBtn.onClick.has(onFriendReqClick, this)) { // Adds it once
          requestHelpBtn.onClick.add(onFriendReqClick, this);
        }

        requestHelpBtn.addChild(gift);
      }
    };

    requestHelpBtn.addChild(buttonContainer);
    requestHelpBtn.addChild(requestHelpText);
    requestHelpBtn.x = availableTextSpace - requestHelpBtn.width * 1.7;
    requestHelpBtn.y = this.friendEntryDimensions.height / 2;

    const friendNameText = new G.Text(
      preCalcFriendTextX, 0, friendInfo.friendData.name, blueText, 0, requestHelpBtn.x - (requestHelpBtn.width / 2) - 10 - preCalcFriendTextX,
      this.friendEntryDimensions.height, true,
    );
    friendNameText.y = (this.friendEntryDimensions.height - friendNameText.height) / 2; // Friend text within space

    friendDisplay.addChild(friendBg);
    friendDisplay.addChild(requestHelpBtn);
    friendDisplay.addChild(friendImage);
    friendDisplay.addChild(friendNameText);

    return friendPack; // Done far above
  }

  makeMaskGraphic(visibleDimensions) {
    const maskRadius = G.OMTsettings.requestHelp.positionals.maskRadius || 25;
    const maskLayer = new Phaser.Graphics(game); // Mask
    maskLayer.beginFill(0, 0);
    maskLayer.lineTo(0, 0); // Mask is now a complicated graphic
    maskLayer.lineTo(visibleDimensions.width, 0);
    maskLayer.lineTo(visibleDimensions.width, visibleDimensions.height - (maskRadius - 1));
    maskLayer.lineTo(visibleDimensions.width - (maskRadius - 1), visibleDimensions.height);
    maskLayer.lineTo((maskRadius - 1), visibleDimensions.height);
    maskLayer.lineTo(0, visibleDimensions.height - (maskRadius - 1));
    maskLayer.lineTo(0, 0);
    maskLayer.arc(visibleDimensions.width - maskRadius, visibleDimensions.height - maskRadius, maskRadius, 0, Math.PI / 2, false);
    maskLayer.arc(maskRadius, visibleDimensions.height - maskRadius, maskRadius, Math.PI / 2, Math.PI, false);
    maskLayer.endFill();
    maskLayer.x = visibleDimensions.x;
    maskLayer.y = visibleDimensions.y;

    return maskLayer;
  }

  /**
   * Updates this.rh_friendWindow and updates the scroll
   */
  manualFriendWindowUpdate() {
    if (this.currentState !== WindowStates.Friend) { return; }
    this.rh_friendWindow.children.forEach((a) => { a.update(); });
    this.rh_friendContainer.friendDisplays.forEach((a) => { if (a.friendButton) { a.friendButton.update(); } });

    if (this.rh_gingyTutorial && this.saveStateMgr.requestHelp_getTutorialStep() === 0) {
      if (!(this.rh_tutorialHandTarget && this.isWithinVisibleMaskAlt(this.rh_tutorialHandTarget))) { // If theres no hand tutorial or the target is not visible
        this.rh_tutorialHandTarget = null; // TODO: Why is friendcontainer mask = 0,0?
        this.rh_gingyTutorial.setTarget(this.rh_tutorialHandTarget);
        for (let i = 0; i < this.rh_friendContainer.friendDisplays.length; i++) {
          const curDisp = this.rh_friendContainer.friendDisplays[i];
          const isVisibleInMask = this.isWithinVisibleMask(curDisp);
          if (isVisibleInMask && curDisp.friendButton) {
            this.rh_tutorialHandTarget = {
              display: curDisp.friendDisplay,
              target: curDisp.friendButton,
              offset: { x: 0, y: -curDisp.friendButton.height / 2 },
            };
            this.rh_gingyTutorial.setTarget(this.rh_tutorialHandTarget, true);
            break;
          }
        }
      }
    }
  }

  /**
   * Sets the scroll's Y to a specific spot where it would reveal a specific entry
   */
  snapToEntry(friendData) {
    if (this.isWithinVisibleMask(friendData)) { return; } // If its already visible

    let targetFriendIndex = -1;
    for (let i = 0; i < this.rh_friendContainer.friendDisplays.length; i++) {
      const curFriend = this.rh_friendContainer.friendDisplays[i];
      if (curFriend === friendData) {
        targetFriendIndex = i;
        break;
      }
    }

    if (targetFriendIndex === -1) { return; }

    const midpoint = Math.max(-1 + this.numOfVisibleEntries / 2, 0);
    const estimatedHeight = (this.friendEntryDimensions.height * (Math.max(targetFriendIndex - midpoint, 0))); // midpoint for centering the entry to the middle
    const targetY = Math.max(-estimatedHeight, this.friendEntryDimensions.height * (this.numOfVisibleEntries - 0.02));
    this.omtScrollBar.jumpToContentPosition(targetY);
  }

  /**
   * Checks if the one friend Banner is visible in the mask
   * Prioritizes the button
   */
  isWithinVisibleMask(friendBanner) {
    let res = false;
    if (friendBanner && (friendBanner.friendButton || friendBanner.friendDisplay)) {
      const friendBounds = friendBanner.friendButton ? friendBanner.friendButton.getBounds() : friendBanner.friendDisplay.getBounds();
      res = this.omtScrollBar.isWithinMask(friendBounds);
    }
    return res;
  }

  /**
   * Checks if the tutorial target is within the visible mask (because it has a different setup)
   * Prioritizes the target(button)
   */
  isWithinVisibleMaskAlt(tutorialTarget) {
    let res = false;
    if (tutorialTarget && (tutorialTarget.target || tutorialTarget.display)) {
      const friendBounds = tutorialTarget.target ? tutorialTarget.target.getBounds() : tutorialTarget.display.getBounds();
      res = this.omtScrollBar.isWithinMask(friendBounds);
    }
    return res;
  }

  /**
   * Event for when you click on the button for RequestHelp gift at the end of possible friends
   *
   * friendData = this.rh_displayFriendData.friendList      I wish for interfaces.
   * @param {Object} friendData
   */
  async onRequestFriendHelp(friendData) {
    switch (friendData.id) {
      case GINGYID:
        this.onRequestSuccess(friendData); // Act as if success
        break;
      default:
        this.showOverlay(); // Overlay
        // eslint-disable-next-line no-case-declarations
        const result = await OMT.social.sendRequestHelpMessage(friendData); // Wait for response
        if (result) {
          this.onRequestSuccess(friendData); // Yay!
          this.hideOverlay();
        } else {
          console.log('An error has occurred'); // No...?
          this.hideOverlay();
        }
        break;
    }
  }

  /**
   * Better overlay
   */
  showOverlay() {
    this.overlay = game.add.graphics();
    this.overlay.beginFill(0x000000, 0.7);
    this.overlay.drawRect(game.world.bounds.x, game.world.bounds.y, game.width * 1.5, game.height);
    this.overlay.inputEnabled = true;
  }

  /**
   * Function for when the player can spin the wheel for a prize
   */
  onRequestSuccess(friendData) {
    this.changeState(WindowStates.Wheel); // Change to the wheel
    this.saveStateMgr.requestHelp_setOnCooldown(friendData.id, false); // Set the friend on cooldown, now

    // DeltaDNA tracking
    if (friendData.id !== GINGYID) { // Was a real friend
      this.saveStateMgr.requestHelp_trackUniqueFriend(friendData.id, false); // Unique?
      this.rh_inventory.trackingData.numberOfFriendsAsked++; // +1 asked
      this.rh_inventory.trackingData.numberOfMessages++; // +1 messages
    } else if (friendData.id === GINGYID) { // It was a bot!
      this.rh_inventory.trackingData.askedBotThisLevel = true;
    }

    // Set tutorial to next step
    if (this.rh_gingyTutorial && this.saveStateMgr.requestHelp_getTutorialStep() === 0) {
      this.saveStateMgr.requestHelp_setTutorialReappearance(3, false); // Come back another time!
      this.saveStateMgr.requestHelp_setTutorialComplete(1, false);
      this.saveStateMgr.requestHelp_setTutorialStep(1, false);
      this.isTutorialLayout = false;
      this.rh_tutorialHandTarget = null;
      this.rh_gingyTutorial.toggleVisibility(false);

      const layoutPositions = this.getLayoutPosition();
      this.rh_friendWindow.scale.set(layoutPositions.friendWindowScale, layoutPositions.friendWindowScale);
      this.rh_friendWindow.y = layoutPositions.friendWindowY;
      /*{  //Set the next target
        friendDisplay: this.rh_friendWindow,
        friendButton: this.inviteFriendButton
      }; */
    }
    this.saveStateMgr.save();
  }

  getLayoutPosition() {
    let layoutPositions;
    if (this.isTutorialLayout) {
      layoutPositions = {
        friendWindowY: -333,
        titleY: 55,
        subY: 170,
        friendWindowScale: 0.9,
      };
    } else if (this.wideScreenLayout) {
      layoutPositions = {
        friendWindowY: -251,
        titleY: 55,
        subY: 170,
        friendWindowScale: 1,
      };
    } else {
      layoutPositions = {
        friendWindowY: -261,
        titleY: 55,
        subY: 170,
        friendWindowScale: 1,
      };
    }

    return layoutPositions;
  }

  /**
   * Resize function to keep inviteFriendButton close or midway from game.height
   */
  onRequestHelpResize() {
    let inviteButtonSpacing = 0;
    if (this.isTutorialLayout) {
      inviteButtonSpacing = 1;
    } else if (this.wideScreenLayout) {
      inviteButtonSpacing = 0.75;
    } else {
      inviteButtonSpacing = 0.75;
    }
    const safePosition = ((this.inviteFriendButton.height * 2) * inviteButtonSpacing) + this.friendWindowDimension.height;
    const spaceBetween = game.height + (this.rh_friendWindow.y + safePosition);
    this.inviteFriendButton.y = Math.max(safePosition, (safePosition + spaceBetween / 2) / 2);
  }

  /*****************************************************************
  * Prize Screen
  ***************************************************************** */

  /**
   * Draws everything needed for the prize screen
   */
  async prizeScreenInit() {
    const mainDisplay = new Phaser.Group(G.game, this); // The holder for everything

    const prizeScreen = new Phaser.Group(G.game, null);
    const shine1 = G.makeImage(0, 0, 'shine_godrays', 0.5);
    shine1.update = () => { // Spiiin
      if (prizeScreen.visible) {
        shine1.angle += 0.01;
        if (shine1.angle === 360) { shine1.angle = 0; }
      }
    };

    prizeScreen.addChild(shine1);
    mainDisplay.addChild(prizeScreen);

    /*
    let requestMoreHelp = new Phaser.Group(G.Game, null);
    let actualRequestBtn = new G.Button(0, 0, 'medium_button_blue');
    // actualRequestBtn.addTextLabel('font-white', OMT.language.getText('Request More Help'), 70, -2, -2, 200);
    let arbtnText = new G.Text(-2, -2, OMT.language.getText('Request More Help'), {style: 'font-white', fontSize: 70, lineSpacing: -15}, 0.5, 200, actualRequestBtn.height * 0.8, true, "center");
    requestMoreHelp.onChildInputDown.add(() => {
      this.changeState(WindowStates.Friend);  //Changes states back to friend, going back to the loop
    });
    let gift = G.makeImage(-10 - actualRequestBtn.width/2, -10, "gift", 0.5);
    let giftScale = (actualRequestBtn.height*0.85)/187; //187 is its actual height
    let giftOriWidth = gift.width = gift.height = gift.height * giftScale;

    //Gift shaking tween
    let shakeTween1 = game.add.tween(gift).to({angle: -5, width: giftOriWidth*1.05, height: giftOriWidth*1.05}, 500, Phaser.Easing.Sinusoidal.In);
    let shakeTween2 = game.add.tween(gift).to({angle: 5}, 50, Phaser.Easing.Sinusoidal.InOut, false, 0, 2, true);
    let shakeTween3 = game.add.tween(gift).to({angle: 0, width:giftOriWidth, height: giftOriWidth}, 500, Phaser.Easing.Sinusoidal.InOut, false);
    shakeTween1.chain(shakeTween2);
    shakeTween2.chain(shakeTween3);
    let shakeChecker; //Initialize first to be referenced in the function itself
    shakeChecker = () => {  //Will be used later
      if (this.game && gift.visible) {
        game.time.events.add(5000, ()=> {
          if (this.game && gift.visible) { //check again
            shakeTween3.onComplete.addOnce(() => {
              shakeChecker();
            });
            shakeTween1.start();
          }
        }, this);
      }
    };

    let plus = G.makeImage(0, 0, "btn_plus", 0.5);
    plus.height = plus.width = 50;
    plus.x = gift.x + gift.width*0.4;
    plus.y = gift.y + gift.height*0.4;

    requestMoreHelp.addChild(actualRequestBtn);
    requestMoreHelp.addChild(arbtnText);
    requestMoreHelp.addChild(gift);
    requestMoreHelp.addChild(plus);
    */

    const onClick = () => {
      this.closeWindow();
    };
    const continueBtn = new OMT_UI_SquareButton(0, 0, {
      button: {
        tint: BUTTONCOLOURS.green,
        dimensions: {
          width: 196,
          height: 100,
        },
      },
      text: {
        string: OMT.language.getText('Continue'),
        textStyle: { style: 'font-white', fontSize: 70, lineSpacing: -15 },
      },
      options: {
        clickFunction: {
          onClick: onClick.bind(this),
        },
      },
    });
    const helpReceived = new G.Text(0, 0, OMT.language.getText('Help received!'), helpReceivedText, 0.5, 450, 120, true, 'center');

    helpReceived.y = 220;
    continueBtn.y = helpReceived.y + helpReceived.height + 30;

    mainDisplay.addChild(continueBtn);
    mainDisplay.addChild(helpReceived);

    return {
      display: mainDisplay,
      prizeScreen,
      text: helpReceived,
      prize: null, // Phaser.Group. Will be set later
      continueBtn,
      // moreHelpBtn: requestMoreHelp,
      // shakeTween: shakeChecker
    };
  }

  /**
   * Collects the prize internally since it was predetermined.
   */
  collectWheelPrizeInternally(prizeList) {
    // The item is supposed to be put into your temp inventory immediately since...
    // The item is predetermined, and if the player crashes, they still enter cooldown :'(
    this.prizeList = prizeList;
    // - As of OMT-1227, the list doesn't need to be changed anymore but just in case.
    // Extracts the booster
    const booster = this.prizeList.current[this.prizeList.predeterminedPrize];

    // Turns the slot into a coin
    // this.prizeList.current[this.prizeList.predeterminedPrize] = this.prizeList.off[this.prizeList.predeterminedPrize];

    // Adds it in
    this.rh_inventory.addToInventory(booster);

    // this.rh_wheel.updatePrizeList(this.prizeList);  //Updates the prizelist in the wheel
  }

  /**
   * Collects the prize visually! With the tweens and everything!
   */
  collectWheelPrizeVisually(prizeList) {
    if (this.rh_prizePack.prize) { // Removes the old prize
      const oldPrize = this.rh_prizePack.prize;
      this.rh_prizePack.prizeScreen.removeChild(oldPrize);
      oldPrize.destroy(true);
    }

    const chosenPrize = prizeList.current[prizeList.predeterminedPrize];
    let giftString = OMT_UI_DrawUtil.getGiftString(chosenPrize.prize);
    const isCoin = giftString.indexOf('coin') > -1;
    if (isCoin) { giftString = giftString.replace('_1', '_3'); } // "coin_3", I don't want to modify the giftString func for this one case
    // Becomes "coin_3" and doesn't look super pixelated

    const prize = new Phaser.Group(G.Game, null); // Holds the image
    const giftImage = G.makeImage(0, 0, giftString, 0.5, null);
    giftImage.width = giftImage.height = 200;
    if (isCoin) { // If its coin, add text
      const giftText = new G.Text(0, 0, chosenPrize.amount, prizeText, 0);
      giftText.x = 0 - giftText.width / 2;
      giftText.y = giftImage.y + giftImage.height / 2;

      prize.addChild(giftText);
    }
    prize.addChild(giftImage);
    this.rh_prizePack.prizeScreen.addChild(prize);
    this.rh_prizePack.prize = prize; // Assigns prize

    // Applies things for the tween
    this.rh_prizePack.prizeScreen.visible = false;
    this.rh_prizePack.prizeScreen.scale.x = this.rh_prizePack.prizeScreen.scale.y = 0.01;
    this.rh_wheel.container.scale.x = this.rh_wheel.container.scale.y = 1;
    // this.rh_prizePack.moreHelpBtn.alpha =
    this.rh_prizePack.continueBtn.alpha = this.rh_prizePack.text.alpha = 0;

    const originalTextY = this.rh_prizePack.text.y;
    const originalContinueY = this.rh_prizePack.continueBtn.y;
    // let originalMoreHelpY = this.rh_prizePack.moreHelpBtn.y;
    this.rh_prizePack.continueBtn.y += 500;
    // this.rh_prizePack.moreHelpBtn.y += 500;
    this.rh_prizePack.text.y += 500;

    // Tween
    const goodbyeWheel = game.add.tween(this.rh_wheel.container.scale)
      .to({ x: 0.01, y: 0.01 }, 200, Phaser.Easing.Custom.SoftBounce);

    const comeInPrize = game.add.tween(this.rh_prizePack.prizeScreen.scale)
      .to({ x: 1, y: 1 }, 200, Phaser.Easing.Sinusoidal.InOut, false);
    const alphaPrize = game.add.tween(this.rh_prizePack.prizeScreen)
      .to({ alpha: 1 }, 200, Phaser.Easing.Sinusoidal.InOut, false);

    const comeInText = game.add.tween(this.rh_prizePack.text)
      .to({ y: originalTextY, alpha: 1 }, 200, Phaser.Easing.Sinusoidal.InOut);
    const comeContinue = game.add.tween(this.rh_prizePack.continueBtn)
      .to({ y: originalContinueY, alpha: 1 }, 200, Phaser.Easing.Sinusoidal.InOut);
    comeContinue.onStart.add(() => {
      game.add.tween(this.rh_prizePack.continueBtn)
        .to({ alpha: 1 }, 200, Phaser.Easing.Sinusoidal.InOut, true);
    });
    // let comeMoreHelp = game.add.tween(this.rh_prizePack.moreHelpBtn)
    //   .to({y:originalMoreHelpY, alpha:1}, 200, Phaser.Easing.Sinusoidal.InOut);


    comeInPrize.onComplete.addOnce(() => {
      this.rh_inventory.arrangeInventory(); // Positions inventory items
      // this.rh_prizePack.shakeTween(); //Now it starts the shake tween
      // if (this.rh_inventory.items.length == 1) {  //Item gets added to inventory before the item is shown visually
      //   this.rh_inventory.toggleInventory(true);  //Brings down inv
      // }
    });

    if (isCoin) { // If its a coin, when it comes in, add the coin particles
      comeInPrize.onComplete.addOnce(() => {
        if (game.state.current === 'World') { // animate coins for game state
          this.state.uiTargetParticles.createCoinBatch(
            game.world.bounds.x + this.rh_prizePack.prizeScreen.worldPosition.x,
            this.rh_prizePack.prizeScreen.worldPosition.y,
            this.state.panel.coinsTxt,
            chosenPrize.amount,
            true,
          );
        }
      });
    }

    goodbyeWheel.onComplete.add(() => { // When the wheel is gone, bring in the prize
      this.rh_wheel.container.visible = false;
      this.rh_prizePack.prizeScreen.visible = true;
      comeInText.start();
      alphaPrize.start();
    });
    comeInText.chain(comeInPrize);
    comeInPrize.chain(comeContinue);
    goodbyeWheel.start();
  }


  /** ********************************************
   * Tutorial
   *******************************************/
  /**
   * Shows which tutorial to show based on step
   */
  tutorialStep(step) {
    // eslint-disable-next-line default-case
    switch (step) {
      case 0:
        this.rh_gingyTutorial.displayMsg(G.json.tutorials.RequestHelpTutorial.requestHelp0);
        break;
      case 1:
        this.rh_gingyTutorial.displayMsg(G.json.tutorials.RequestHelpTutorial.requestHelp1);
        break;
      case 2:
        this.rh_gingyTutorial.displayMsg(G.json.tutorials.RequestHelpTutorial.requestHelp2);
        if (this.saveStateMgr.requestHelp_getTutorialComplete() >= 10) {
          this.saveStateMgr.requestHelp_setTutorialStep(-1, false); // Sets it to done and it should never come back!
          this.saveStateMgr.requestHelp_setTutorialReappearance(-1, false);
          this.saveStateMgr.save();
        }
        // game.time.events.add(5000, ()=> { //tutorial gingy goes away later
        //   if (this.rh_gingyTutorial) {
        //     this.rh_gingyTutorial.hide();
        //   }
        // }, this);
    }
  }
}

// create global references
if (!window.Windows) window.Windows = {};
Windows.requestHelp = requestHelp;
